export default __webpack_public_path__ + "static/6-267f3d2355fc6b812e7e6c0b77d5c941.jpg";